import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Paper } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '4px 4px 6px 1px rgba(0,0,0,0.2)'
  },
  gutterBottom: {
    marginBottom: theme.spacing(2)
  },
  padding: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1)
  },
  fullHeight: {
    height: '100%'
  }
}));


function NPaper(props) {
  const classes = useStyles();
  const { style } = props;

  return (
    <Paper
      className={`
        ${classes.root}
        ${props.className}
        ${props.gutterBottom && classes.gutterBottom}
        ${props.padded && classes.padding}
        ${props.fullHeight && classes.fullHeight}
      `}
      style={style}
    >
      {props.children}
    </Paper>
  );
}

NPaper.propTypes = {
  padded: PropTypes.bool,
  gutterBottom: PropTypes.bool,
  fullHeight: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string
}

export default NPaper;
